<ion-content class="app-content cabinet-content">
    <div id="users">
        <ul>
            <li *ngFor="let child of childrenSorted" [class]="getUserClass (child)" (click)="setCurrentUser (child);">
                <span class="pos">{{child.nick || child.name}}</span>
            </li>

        </ul>
    </div>
    <div id="logout">
        <button (click)="logout ();">LOG OUT</button>
    </div>
</ion-content>